"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useQuestionSelectionActions = require("../../hooks/questionnaire/useQuestionSelectionActions");
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _SliderPicker = require("./SliderPicker/SliderPicker");
var _coreIconPicker = require("@vfuk/core-icon-picker");
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _r10CommonComponents = require("r10-common-components");
var _utils = require("../../utils/utils");
var _constants = require("../../utils/constants");
var _useAppDispatch = require("../../hooks/useAppDispatch");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  flex: 1;
  flex-basis: 100%;
`;
const StyledImagePickerItem = (0, _styledComponents.default)('div')(props => props.enable && (0, _styledComponents.css)`
      & [class*='FunctionalPickerItemstyle__FunctionalPickerItemContainer'] {
        display: flex !important;
        margin-bottom: 0 !important;
        width: 100px;
        height: 68px;
      }
      & [class*='FunctionalPickerItemstyle__ChildWrapper'] {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        width: 100%;
        margin-bottom: 0 !important;
      }
    `);
const StyledPicker = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    & label:focus,
    & label:focus-visible,
    & label:focus-within {
      box-shadow: 0 0 0 ${props.pickerBoxShadow}px ${props.pickerBoxShadowColor};
    }
    & span[class*='FunctionalPickerItemstyle__Title'] {
      line-height: ${props.pickerLineHeight}px;
    }
  `);
const PickerWrapper = (0, _styledComponents.default)('div')(props => props.enable && (0, _styledComponents.css)`
      & [class*='Pickerstyle__Fieldset'] {
        padding:0 !important;
      }
      & [class*='FunctionalPickerItemstyle__FunctionalPickerItemContainer'] {
        display: flex !important;
        width:100%;     
    `);
const mapChoices = choices => {
  const pickerOptions = [];
  const imagePickerOptions = [];
  const iconPickerOptions = [];
  choices.forEach((choice, index) => {
    const option = {
      id: `picker-item-${index}`,
      title: choice.text,
      value: choice.text,
      isDefault: !!choice.isDefault
    };
    if (choice !== null && choice !== void 0 && choice.image) {
      imagePickerOptions.push({
        ...option,
        title: choice.displayImageOnly ? '' : choice.text,
        image: {
          alt: choice.text,
          src: (0, _utils.getImagePath)(choice.image)
        }
      });
    } else if (choice !== null && choice !== void 0 && choice.icon) {
      iconPickerOptions.push({
        ...option,
        icon: {
          name: choice.icon
        }
      });
    } else {
      pickerOptions.push(option);
    }
  });
  return {
    pickerOptions,
    imagePickerOptions,
    iconPickerOptions
  };
};
const QuestionWithTiles = _ref => {
  let {
    question,
    selections
  } = _ref;
  const {
    maxSelections
  } = question;
  const isSelected = choice => selections.includes(choice.text);
  const {
    addSelection,
    removeSelection,
    replaceSelection,
    checkDefaultChoice
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  const imagePickerColumnsNumber = (0, _useLocalTheme.default)('imagePickerColumnsNumber', 2);
  const imagePickerOrientation = (0, _useLocalTheme.default)('imagePickerOrientation', 'horizontal');
  const pickerBoxShadow = (0, _useLocalTheme.default)('pickerBoxShadow', 3);
  const pickerBoxShadowColor = (0, _useLocalTheme.default)('pickerBoxShadowColor', '#00697C');
  const pickerLineHeight = (0, _useLocalTheme.default)('pickerLineHeight', 26);
  const hasDefault = question.choices.some(choice => choice.isDefault);
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const enableShadowDOM = (0, _useConfig.default)('enableShadowDOM', false);
  const equalizeAnswersHeights = () => {
    const divs = enableShadowDOM ? document.getElementById('gs-app').shadowRoot.querySelectorAll('#gs-app-shadow fieldset [class*="SimpleGridstyle__SimpleGridColumn"]') : document.querySelectorAll('fieldset [class*="SimpleGridstyle__SimpleGridColumn"]');
    let maxHeight = 0;
    divs.forEach(div => {
      div.style.minHeight = 'unset';
    });
    divs.forEach(div => {
      maxHeight = Math.max(maxHeight, div.offsetHeight);
    });
    divs.forEach(div => {
      div.style.minHeight = maxHeight + 'px';
    });
  };
  (0, _react.useEffect)(() => {
    window.addEventListener('resize', equalizeAnswersHeights);
    return () => {
      window.removeEventListener('resize', equalizeAnswersHeights);
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (!(selections !== null && selections !== void 0 && selections.length)) checkDefaultChoice();
    if ((question === null || question === void 0 ? void 0 : question.id) === _constants.QUESTION_ID.PLAN_NUMBER || (question === null || question === void 0 ? void 0 : question.id) === _constants.QUESTION_ID.ROAMING) dispatch((0, _recommendationActions.setAdditionalPlans)(1));
    if ((question === null || question === void 0 ? void 0 : question.id) === _constants.QUESTION_ID.ONE_PLAN) dispatch((0, _recommendationActions.setAdditionalPlans)(0));
    equalizeAnswersHeights();
  }, [question]);
  const shouldRemoveSelection = choice => {
    return isSelected(choice) && (!hasDefault || hasDefault && (selections === null || selections === void 0 ? void 0 : selections.length) > 1);
  };
  const getSelectedChoice = choiceText => {
    return question.choices.find(choice => choice.text === choiceText);
  };
  const handleSelectedChoiceRemoval = choice => {
    if (shouldRemoveSelection(choice)) {
      removeSelection(choice.text);
    }
  };
  const handleSelectedChoiceAddition = choice => {
    var _choice$exclusive;
    const isExclusiveSelection = (_choice$exclusive = choice === null || choice === void 0 ? void 0 : choice.exclusive) !== null && _choice$exclusive !== void 0 ? _choice$exclusive : false;
    dispatch((0, _questionnaireActions.setIsExclusiveSelection)(isExclusiveSelection));
    if (maxSelections === 1) {
      replaceSelection(choice.text);
      return;
    }
    handleExclusiveSelections(choice);
    if (!maxSelections || (selections === null || selections === void 0 ? void 0 : selections.length) < maxSelections) {
      addSelection(choice.text);
    }
  };
  const handleExclusiveSelections = currentChoice => {
    question.choices.filter(c => c.text !== currentChoice.text && c.exclusive !== currentChoice.exclusive && isSelected(c)).forEach(c => removeSelection(c.text));
  };
  const onSelectionClick = e => {
    const selectedChoice = getSelectedChoice(e.target.value);
    if (isSelected(selectedChoice)) {
      handleSelectedChoiceRemoval(selectedChoice);
    } else {
      handleSelectedChoiceAddition(selectedChoice);
    }
  };
  const {
    pickerOptions,
    imagePickerOptions,
    iconPickerOptions
  } = mapChoices(question.choices);
  const ImagePickerComponent = imagePickerOrientation === 'vertical' ? _r10CommonComponents.ImagePickerItem : _r10SourceLibrary.ImagePicker;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "question-with-tiles"
  }, pickerOptions.length !== 0 && /*#__PURE__*/_react.default.createElement(StyledGridRow, {
    className: "choice-with-text"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 2
    }
  }, question.viewAs === 'slider' ? /*#__PURE__*/_react.default.createElement(_SliderPicker.SliderPicker, {
    onChange: onSelectionClick,
    selected: selections,
    label: question.title,
    items: pickerOptions,
    border: question.sliderStyle === _constants.SLIDER_STYLES.BORDERED
  }) : /*#__PURE__*/_react.default.createElement(PickerWrapper, {
    enable: imagePickerOrientation === 'vertical'
  }, /*#__PURE__*/_react.default.createElement(StyledPicker, {
    pickerBoxShadow: pickerBoxShadow,
    pickerLineHeight: pickerLineHeight,
    pickerBoxShadowColor: pickerBoxShadowColor
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Picker, {
    onChange: onSelectionClick,
    selected: selections,
    groupName: 'Default',
    items: pickerOptions,
    columns: {
      sm: 1,
      md: pickerOptions.length > 1 ? 2 : 1,
      lg: pickerOptions.length > 1 ? 2 : 1
    }
  })))))), imagePickerOptions.length !== 0 && /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(StyledImagePickerItem, {
    enable: imagePickerOrientation === 'vertical'
  }, /*#__PURE__*/_react.default.createElement(ImagePickerComponent, {
    id: "choice-with-image",
    onChange: onSelectionClick,
    selected: selections,
    label: question.title,
    groupName: 'Default',
    items: imagePickerOptions,
    orientation: imagePickerOrientation,
    columns: {
      sm: 1,
      md: imagePickerOptions.length > 1 ? imagePickerColumnsNumber : 1,
      lg: imagePickerOptions.length > 1 ? imagePickerColumnsNumber : 1
    }
  })))), iconPickerOptions.length !== 0 && /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_coreIconPicker.IconPicker, {
    id: "choice-with-icon",
    onChange: onSelectionClick,
    selected: selections,
    label: question.title,
    groupName: 'Default',
    items: iconPickerOptions,
    iconOrientation: 'horizontal',
    columns: {
      sm: 1,
      md: iconPickerOptions.length > 1 ? 2 : 1,
      lg: iconPickerOptions.length > 1 ? 2 : 1
    }
  }))));
};
var _default = QuestionWithTiles;
exports.default = _default;